export default {
  getRouting: state => state.costings.detailed.routings,
}
